import { DateTime } from 'luxon'

export function hasDST(dateISOString) {
  return (
    DateTime.fromISO(dateISOString).set({ month: 7 }).isInDST !=
    DateTime.fromISO(dateISOString).set({ month: 1 }).isInDST
  )
}
